// import { AuthService } from './AuthService';

import { IUserInfo } from '@/shared/IUserInfo';
import { ApiService } from './ApiService';
import { INVITE_TYPE } from '@/shared/constants';

export class UserInfoService {
  
  public static async ensureUser(user: IUserInfo, invite: INVITE_TYPE): Promise<{ ensured: IUserInfo, invited?: boolean }> {
    const result = await ApiService.fetch<{ensured: IUserInfo, invited?: boolean}>(`/api/user/ensureUser`, 'POST', { 
      name: user.name,
      email: user.email,
      invite
    });
    return result;
  }

  public static async getSiteUsers(): Promise<IUserInfo[]> {
    const result = await ApiService.fetch<IUserInfo[]>(`/api/user/siteUsers`);
    const sorted = result.sort((a, b) => (a.name || a.email || '').localeCompare(b.name || b.email || ''));
    return sorted;
  }

  // public static async getUserPhotoUrl(): Promise<string | undefined> {
  //   const graph = AuthService.getGraphClient();
  //   const photoValue = await graph.api('/me/photos/240x240/$value').get();
  //   const blobUrl = URL.createObjectURL(photoValue);
  //   return blobUrl;
  // }
}